import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  Type,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

import { ListEntryTypes, ListItem, ListProperty } from '@site-mate/dashpivot-shared-library';

import { ListFieldAttachmentComponent } from 'app/lists/list-field-attachment/list-field-attachment.component';
import { ListFieldDateComponent } from 'app/lists/list-field-date/list-field-date.component';
import { ListFieldDateExpiryComponent } from 'app/lists/list-field-date-expiry/list-field-date-expiry.component';
import { ListFieldNumberComponent } from 'app/lists/list-field-number/list-field-number.component';
import { ListFieldTextComponent } from 'app/lists/list-field-text/list-field-text.component';
import { ListFieldBaseComponent } from 'app/shared/model/lists/list-field-base-component.model';

import { ListItemPropertyMap } from '../list-item-property-map.type';
import { ListPropertyHostDirective } from '../list-property-host.directive';

@Component({
  selector: 'cc-list-property',
  template: `<ng-template ccListPropertyHost></ng-template>`,
})
export class ListPropertyComponent implements AfterViewInit {
  @Input() item: ListItem;
  @Input() listItemPropertyMap: ListItemPropertyMap;
  @Input() editable: boolean;
  @Output() propertyUpdated = new EventEmitter<any>();
  @Input() propertyHeader: ListProperty;
  @Input() companyId?: string;
  @Input() projectId?: string;
  @Input() listId: string;

  private readonly componentMap = new Map<string, Type<ListFieldBaseComponent>>([
    [ListEntryTypes.Text, ListFieldTextComponent],
    [ListEntryTypes.Number, ListFieldNumberComponent],
    [ListEntryTypes.Date, ListFieldDateComponent],
    [ListEntryTypes.DateExpiry, ListFieldDateExpiryComponent],
    [ListEntryTypes.Attachment, ListFieldAttachmentComponent],
  ]);

  @ViewChild(ListPropertyHostDirective, { static: true }) dynamicHost: ListPropertyHostDirective;
  private unSubscribe = new Subject<void>();
  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.loadComponent();
    this.cdr.detectChanges();
  }

  loadComponent() {
    if (!this.propertyHeader) {
      return;
    }
    const componentType = this.componentMap.get(this.propertyHeader.kind);

    const component = this.dynamicHost.viewContainerRef.createComponent(componentType);
    component.instance.item = this.item;
    component.instance.editable = this.editable;
    component.instance.property = this.listItemPropertyMap.get(this.item._id).get(this.propertyHeader._id);
    component.instance.companyId = this.companyId;
    component.instance.projectId = this.projectId;
    component.instance.listId = this.listId;
    component.instance.propertyUpdated.pipe(takeUntil(this.unSubscribe)).subscribe((value) => {
      this.propertyUpdated.emit(value);
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
